import { Component, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';


@Component({
  selector: 'app-test',
  templateUrl: './test.page.html',
  styleUrls: ['./test.page.scss'],

})
export class TestPage implements OnInit {


  constructor(public toastController: ToastController) {

  }

  ngOnInit() {

  }


}
